module.exports = __webpack_public_path__ + "img/img1_14.d490fadb.jpeg";